import { render, staticRenderFns } from "./TrainingView.vue?vue&type=template&id=5da4ee13&scoped=true&"
import script from "./TrainingView.vue?vue&type=script&lang=ts&"
export * from "./TrainingView.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingView.vue?vue&type=style&index=0&id=5da4ee13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da4ee13",
  null
  
)

export default component.exports